import { render, staticRenderFns } from "./transition.vue?vue&type=template&id=4b8789f6&scoped=true"
import script from "./transition.vue?vue&type=script&lang=js"
export * from "./transition.vue?vue&type=script&lang=js"
import style0 from "./transition.vue?vue&type=style&index=0&id=4b8789f6&prod&lang=less"
import style1 from "./transition.vue?vue&type=style&index=1&id=4b8789f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8789f6",
  null
  
)

export default component.exports